export default __webpack_public_path__ + "static/media/Martiyers5.3a915876.jpg";